import api from './api'

const reviewService = {
  // Create a new review
  createReview: async (reviewData) => {
    try {
      const response = await api.post('/reviews', reviewData)
      return response.data
    } catch (error) {
      throw error.response?.data || error
    }
  },

  // Get reviews for a specific item (tour, car, guide)
  getReviews: async (type, id, status = 'approved') => {
    try {
      const response = await api.get(`/reviews/${type}/${id}?status=${status}`)
      return response.data
    } catch (error) {
      throw error.response?.data || error
    }
  },

  // Get user's reviews
  getUserReviews: async () => {
    try {
      const response = await api.get('/reviews/user/my-reviews')
      return response.data
    } catch (error) {
      throw error.response?.data || error
    }
  },

  // Get all reviews (admin only)
  getAllReviews: async (filters = {}) => {
    try {
      const params = new URLSearchParams(filters).toString()
      const response = await api.get(`/reviews/admin/all?${params}`)
      return response.data
    } catch (error) {
      throw error.response?.data || error
    }
  },

  // Update review status (admin only)
  updateReviewStatus: async (id, status, admin_note = '') => {
    try {
      const response = await api.put(`/reviews/admin/${id}/status`, {
        status,
        admin_note,
      })
      return response.data
    } catch (error) {
      throw error.response?.data || error
    }
  },

  // Delete review (admin only)
  deleteReview: async (id) => {
    try {
      const response = await api.delete(`/reviews/admin/${id}`)
      return response.data
    } catch (error) {
      throw error.response?.data || error
    }
  },
}

export default reviewService
